module.exports = __webpack_public_path__ + "img/logo_icon.6ca81c57.png";